import i18n from '@/i18n/index.js'
import swal from 'vue-sweetalert2';
import router from '@/router';
import store from '@/store';

export default {
    // Permission = benötigte Berechtigung, redirect = Soll auf Startseite zurückgeleitet werden
    // Berechtigung vorhanden: true | Berechtigung nicht vorhanden: false
    // checkPermission(){
    //   return true;
    // },
    checkPermission(permission, redirect = true){
      // let roles = store.getters.role
      // if(roles != null && roles.includes("superadmin")){
      //   return true;
      // }
       let permissions = store.getters.permissions
      if (permissions.indexOf(permission) == -1) {
        if(router.currentRoute.path != ("/")){
        new swal({
          icon: 'error',
          title: i18n.t('sorry'),
          text: i18n.t('noperms')
        })}
      if(redirect == true){
          if(router.currentRoute.path == ("/")){
            router.push("/fallback")
          }else{
            router.push('/');
          }
      }
        return false;
      }else{
          return true;
      }
    }
}